<button class="btn btn-primary" (click)="back()">&lt; Back</button>
<h2>Pay Bill</h2>
<ul class="cards">
    <li *ngFor="let category of billerCategories"><a (click)="openPayBill(category)"><img src="/assets/img/dashboard/cash_in.svg">{{ category.name }}</a></li>
</ul>